/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { LoadPagedResult } from '../../models/load-paged-result';

export interface MonitorGetLoadsByClientLoadPost$Params {
  ClientCode?: string;
  OrderId?: string;
  pageNumber?: number;
  pageSize?: number;
}

export function monitorGetLoadsByClientLoadPost(http: HttpClient, rootUrl: string, params?: MonitorGetLoadsByClientLoadPost$Params, context?: HttpContext): Observable<StrictHttpResponse<LoadPagedResult>> {
  const rb = new RequestBuilder(rootUrl, monitorGetLoadsByClientLoadPost.PATH, 'post');
  if (params) {
    rb.query('ClientCode', params.ClientCode, {});
    rb.query('OrderId', params.OrderId, {});
    rb.query('pageNumber', params.pageNumber, {});
    rb.query('pageSize', params.pageSize, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<LoadPagedResult>;
    })
  );
}

monitorGetLoadsByClientLoadPost.PATH = '/Monitor/GetLoadsByClientLoad';
